import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type CreateAssessmentParams = {
  jurySessionId: number;
};

const { useCreate: useJuryAssessmentCreation, useFind: useJuryAssessments } = getCRUDHooks({
  entityName: 'juryAssessments',
  find: ({ jurySessionId }) =>
    clientApi
      .getOCClient()
      .helpers.learningActivity.jurySessions.id(jurySessionId)
      .assessments.find(),
  create: (newAssessment, { jurySessionId }: CreateAssessmentParams) =>
    clientApi
      .getOCClient()
      .helpers.learningActivity.jurySessions.id(jurySessionId)
      .assessments.create(newAssessment),
});

export { useJuryAssessmentCreation, useJuryAssessments };
